<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title: string;
    icon: string;
    open?: boolean;
  }>(),
  {
    open: true,
  }
);

const open = ref(props.open);
</script>

<template>
  <div class="space-y-[2px]">
    <div
      class="flex items-center justify-between cursor-pointer py-2 gap-2"
      @click="open = !open"
    >
      <i :class="['text-md text-gray-600 pi', icon]"></i>
      <p class="flex-1 text-sm font-bold text-[#4B5563]">{{ title }}</p>

      <i
        :class="[
          'text-md text-gray-600 transition duration-500 ease-in-out pi',
          open ? 'pi-angle-down' : 'pi-angle-up',
        ]"
      ></i>
    </div>

    <slot v-if="open" />
  </div>
</template>
